import sanitizeHtml from 'sanitize-html'
import { sanitizeOptions } from 'ui-common/energy/sanitize'

export default ({ app }) => {
  app.config.globalProperties.$sanitize = (v, options = null) => {
    return sanitizeHtml(v, options ?? sanitizeOptions)
  }
}
